function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/* codex-lume-client-scene-cards-global-20260509 */
(function () {
  if (window.__codexLumeClientSceneCardsGlobal20260509) return;
  window.__codexLumeClientSceneCardsGlobal20260509 = true;

  var pagePath = '/pages/lume-client';
  var styleId = 'codex-lume-client-scene-cards-global-20260509';
  var scenes = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0752/0252/7551/t/1/assets/lume-2088-gm-same-background-v1.jpg',
      alt: 'LUME 2088 tapware in a rendered bathroom setting'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0752/0252/7551/t/1/assets/lume-2517-gm.jpg?v=1778219410',
      alt: 'LUME 2517B tapware in a rendered bathroom setting'
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0752/0252/7551/t/1/assets/lume-lume-2922-product.jpg?v=1778217836',
      alt: 'LUME 2922 tapware in a rendered bathroom setting'
    }
  ];

  function isTargetPage() {
    return window.location && window.location.pathname === pagePath;
  }

  function ensureStyle() {
    if (!isTargetPage() || document.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      'html body .lume-family .lf-visual.codex-scene-card{position:relative!important;overflow:hidden!important;isolation:isolate!important;background:radial-gradient(circle at 50% 42%,rgba(255,255,255,.62),transparent 36%),linear-gradient(180deg,#eeeae5 0%,#d8d3ce 100%)!important;}',
      'html body .lume-family .lf-visual.codex-scene-card:before{content:""!important;position:absolute!important;inset:0!important;z-index:0!important;background-image:var(--scene)!important;background-size:cover!important;background-position:center!important;filter:blur(22px) saturate(.94) brightness(.96)!important;transform:scale(1.14)!important;opacity:.36!important;pointer-events:none!important;}',
      'html body .lume-family .lf-visual.codex-scene-card:after{content:""!important;position:absolute!important;inset:0!important;z-index:0!important;background:radial-gradient(circle at 50% 42%,rgba(255,255,255,.28),transparent 34%),linear-gradient(180deg,rgba(250,247,243,.2),rgba(232,224,216,.42))!important;pointer-events:none!important;}',
      'html body .lume-family .lf-visual.codex-scene-card img.scene{position:relative!important;z-index:1!important;width:auto!important;height:100%!important;max-width:100%!important;max-height:100%!important;object-fit:contain!important;object-position:center bottom!important;border:0!important;border-radius:0!important;box-shadow:none!important;mix-blend-mode:normal!important;filter:drop-shadow(0 1.8rem 2rem rgba(0,0,0,.18))!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function applyScenes() {
    if (!isTargetPage()) return;
    ensureStyle();
    var cards = document.querySelectorAll('.lume-family .lf-products .lf-card');
    if (!cards || cards.length < 3) return;
    scenes.forEach(function (scene, index) {
      var card = cards[index];
      var visual = card && card.querySelector('.lf-visual');
      var img = visual && visual.querySelector('img');
      if (!visual || !img) return;
      visual.className = 'lf-visual scene-card codex-scene-card';
      visual.style.setProperty('--scene', 'url("' + scene.src + '")');
      img.className = 'scene';
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (img.getAttribute('src') !== scene.src) img.setAttribute('src', scene.src);
      img.setAttribute('alt', scene.alt);
      img.style.mixBlendMode = 'normal';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyScenes);
  applyScenes();
  window.addEventListener('pageshow', applyScenes);
  window.setTimeout(applyScenes, 250);
  window.setTimeout(applyScenes, 1000);
  window.setTimeout(applyScenes, 2200);
})();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


/* codex-hide-brand-nav-assets-20260511 */
(function() {
  var selectors = [
    'header a[href*="/collections/grohe"]',
    'header a[href*="/pages/lume"]',
    '.menu-drawer a[href*="/collections/grohe"]',
    '.menu-drawer a[href*="/pages/lume"]',
    '#menu-drawer a[href*="/collections/grohe"]',
    '#menu-drawer a[href*="/pages/lume"]'
  ];
  function hideBrandNav() {
    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(link) {
        var item = link.closest('li') || link.closest('details') || link;
        item.setAttribute('hidden', 'hidden');
        item.style.display = 'none';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideBrandNav);
  } else {
    hideBrandNav();
  }
  window.addEventListener('pageshow', hideBrandNav);
  try {
    new MutationObserver(hideBrandNav).observe(document.documentElement, { childList: true, subtree: true });
  } catch (error) {}
})();

/* codex-basin-global-v2:start 2026-05-14T11-01-54-229Z */
(function(){
  var coverMap = {"aqualux-basin-cabinet-aq01":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/aqualux-basin-cabinet-aq01-white-edge-repaired-cover-v3-20260514.png?v=1778749958","alt":"AQUALUX BASIN CABINET AQ01 white edge repaired product cover v3 20260514"},"bc-450-wam":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-450-wam-white-edge-repaired-cover-v3-20260514.png?v=1778750281","alt":"VETTA OL 450 WAM BASIN white edge repaired product cover v3 20260514"},"bc-ol380-fl":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-ol380-fl-white-edge-repaired-cover-v3-20260514.png?v=1778750193","alt":"VETTA BASIN OL380 FL white edge repaired product cover v3 20260514"},"bc-pt-400ss":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-pt-400ss-white-edge-repaired-cover-v3-20260514.png?v=1778750185","alt":"VETTA BAISN PT 400SS white edge repaired product cover v3 20260514"},"bc-pt-vt-410":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-pt-vt-410-white-edge-repaired-cover-v3-20260514.png?v=1778750387","alt":"VETTA VT 410 BASIN white edge repaired product cover v3 20260514"},"bc-pt400mwf":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-pt400mwf-white-edge-repaired-cover-v3-20260514.png?v=1778750176","alt":"VETTA BAISN PT 400MWF white edge repaired product cover v3 20260514"},"bc-pt400mwf-1":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-pt400mwf-1-white-edge-repaired-cover-v3-20260514.png?v=1778750203","alt":"VETTA BASIN OL390FD white edge repaired product cover v3 20260514"},"bc-pt7212":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-pt7212-white-edge-repaired-cover-v3-20260514.png?v=1778750395","alt":"VETTA WALL MOUNT BASIN PT7948 white edge repaired product cover v3 20260514"},"bc-sd-basin-115":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-sd-basin-115-white-edge-repaired-cover-v3-20260514.png?v=1778750246","alt":"VETTA FREE STANDING BASIN PT115 white edge repaired product cover v3 20260514"},"bc-sd-basin-121":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-sd-basin-121-white-edge-repaired-cover-v3-20260514.png?v=1778750229","alt":"VETTA FREE STANDING BASIN PT 121 white edge repaired product cover v3 20260514"},"bc-sd-basin-126":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-sd-basin-126-white-edge-repaired-cover-v3-20260514.png?v=1778750237","alt":"VETTA FREE STANDING BASIN PT 126 white edge repaired product cover v3 20260514"},"bc-sd-basin-150":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/bc-sd-basin-150-white-edge-repaired-cover-v3-20260514.png?v=1778750263","alt":"VETTA FREE STANDING BASIN PT150 white edge repaired product cover v3 20260514"},"vatte-pt-5040-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt-5040-basin-white-edge-repaired-cover-v3-20260514.png?v=1778749967","alt":"VATTE PT 5040 BAISN white edge repaired product cover v3 20260514"},"vatte-pt1801-under-mount-basin-465x385mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt1801-under-mount-basin-465x385mm-white-edge-repaired-cover-v3-20260514.png?v=1778749976","alt":"VATTE PT1801 UNDER MOUNT BASIN 465X385MM white edge repaired product cover v3 20260514"},"vatte-pt1806-under-mount-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt1806-under-mount-basin-white-edge-repaired-cover-v3-20260514.png?v=1778749985","alt":"VATTE PT1806 UNDER MOUNT BASIN 465X335MM white edge repaired product cover v3 20260514"},"vatte-pt2264-under-mount-basin-630x430mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt2264-under-mount-basin-630x430mm-white-edge-repaired-cover-v3-20260514.png?v=1778749993","alt":"VATTE PT2264 UNDER MOUNT BASIN 630X430MM white edge repaired product cover v3 20260514"},"vatte-pt2264-under-mount-basin-630x430mm-copy":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt2264-under-mount-basin-630x430mm-copy-white-edge-repaired-cover-v3-20260514.png?v=1778750072","alt":"VATTE PT551C UNDER MOUNT BASIN 440X440MM white edge repaired product cover v3 20260514"},"vatte-pt2815-under-mount-basin-700x380mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt2815-under-mount-basin-700x380mm-white-edge-repaired-cover-v3-20260514.png?v=1778750002","alt":"VATTE PT2815 UNDER MOUNT BASIN 700X380MM white edge repaired product cover v3 20260514"},"vatte-pt29149-under-mount-basin-620x450mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt29149-under-mount-basin-620x450mm-white-edge-repaired-cover-v3-20260514.png?v=1778750010","alt":"VATTE PT29149 UNDER MOUNT BASIN 620X450MM white edge repaired product cover v3 20260514"},"vatte-pt3749-basin-400x400x130mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt3749-basin-400x400x130mm-no-tap-white-cover-v4-20260514.png?v=1778756216","alt":"VATTE PT3749 WASH BASIN no tap white product cover v4 20260514"},"vatte-pt5240-wash-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt5240-wash-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750028","alt":"VATTE PT5240 WASH BASIN white edge repaired product cover v3 20260514"},"vatte-pt548-under-mount-basin-580x390mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt548-under-mount-basin-580x390mm-white-edge-repaired-cover-v3-20260514.png?v=1778750036","alt":"VATTE PT548 UNDER MOUNT BASIN 580X390MM white edge repaired product cover v3 20260514"},"vatte-pt550-under-mount-basin-470x350mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt550-under-mount-basin-470x350mm-white-edge-repaired-cover-v3-20260514.png?v=1778750045","alt":"VATTE PT550 UNDER MOUNT BASIN 470X350MM white edge repaired product cover v3 20260514"},"vatte-pt551b-under-mount-basin-380x380mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt551b-under-mount-basin-380x380mm-white-edge-repaired-cover-v3-20260514.png?v=1778750054","alt":"VATTE PT551B UNDER MOUNT BASIN 380X380MM white edge repaired product cover v3 20260514"},"vatte-pt551c-under-mount-basin-340x340mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt551c-under-mount-basin-340x340mm-white-edge-repaired-cover-v3-20260514.png?v=1778750063","alt":"VATTE PT551C UNDER MOUNT BASIN 340X340MM white edge repaired product cover v3 20260514"},"vatte-pt552-under-mount-basin-530x375mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vatte-pt552-under-mount-basin-530x375mm-white-edge-repaired-cover-v3-20260514.png?v=1778750081","alt":"VATTE PT552 UNDER MOUNT BASIN 530X375MM white edge repaired product cover v3 20260514"},"vatte-pt5540-wall-mount-basin-550x400mm":{"url":"https://bathcreature.com/cdn/shop/files/vatte-pt5540-white-background-product-cover-20260514.jpg?v=1778727728","alt":"VATTE PT5540 wall mount basin white background product cover"},"vetta-art-basin-eb01":{"url":"https://bathcreature.com/cdn/shop/files/vetta-art-basin-eb01-white-background-product-cover-20260514.jpg?v=1778727768","alt":"VETTA ART BASIN EB01 white background product cover"},"vetta-art-basin-ys01":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys01-white-edge-repaired-cover-v3-20260514.png?v=1778750091","alt":"VETTA ART BASIN YS01 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys02":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys02-white-edge-repaired-cover-v3-20260514.png?v=1778750100","alt":"VETTA ART BASIN YS02 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys03":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys03-white-edge-repaired-cover-v3-20260514.png?v=1778750110","alt":"VETTA ART BASIN YS03 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys04":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys04-white-edge-repaired-cover-v3-20260514.png?v=1778750119","alt":"VETTA ART BASIN YS04 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys04-1":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys04-1-white-edge-repaired-cover-v3-20260514.png?v=1778750129","alt":"VETTA ART BASIN YS05 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys06-400x400x130mm":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys06-400x400x130mm-white-edge-repaired-cover-v3-20260514.png?v=1778750139","alt":"VETTA ART BASIN YS06 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys07":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys07-white-edge-repaired-cover-v3-20260514.png?v=1778750148","alt":"VETTA ART BASIN YS07 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys08":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys08-white-edge-repaired-cover-v3-20260514.png?v=1778750158","alt":"VETTA ART BASIN YS08 white edge repaired product cover v3 20260514"},"vetta-art-basin-ys09":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-art-basin-ys09-white-edge-repaired-cover-v3-20260514.png?v=1778750167","alt":"VETTA ART BASIN YS09 white edge repaired product cover v3 20260514"},"vetta-basin-pt-4835-fz":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-basin-pt-4835-fz-white-edge-repaired-cover-v3-20260514.png?v=1778750211","alt":"VETTA BASIN PT 4835 FZ white edge repaired product cover v3 20260514"},"vetta-basin-pt-5040":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-basin-pt-5040-white-ceramic-edge-repaired-cover-v4-20260514.png?v=1778752800","alt":"VETTA BASIN PT 5040 white ceramic edge repaired product cover v4 20260514"},"vetta-free-standing-basin-pt115-1":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-free-standing-basin-pt115-1-white-edge-repaired-cover-v3-20260514.png?v=1778750255","alt":"VETTA FREE STANDING BASIN PT115-1 white edge repaired product cover v3 20260514"},"vetta-mb01-wash-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-mb01-wash-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750273","alt":"VETTA MB01 WASH BASIN white edge repaired product cover v3 20260514"},"vetta-pt-104-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt-104-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750290","alt":"VETTA PT 104 BASIN white edge repaired product cover v3 20260514"},"vetta-pt-201-wall-mount-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt-201-wall-mount-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750298","alt":"VETTA PT 201 WALL MOUNT BASIN white edge repaired product cover v3 20260514"},"vetta-pt-201-wall-mount-basin-的副本":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt-201-wall-mount-basin-white-edge-repaired-cover-v3-20260514_decbfe55-542c-4a18-b2d6-430b0f5df811.png?v=1778750307","alt":"VETTA PT 202 WALL MOUNT BASIN white edge repaired product cover v3 20260514"},"vetta-pt-360-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt-360-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750316","alt":"VETTA PT 360 BASIN white edge repaired product cover v3 20260514"},"vetta-pt-390-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt-390-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750324","alt":"VETTA PT 390 BASIN white edge repaired product cover v3 20260514"},"vetta-pt-4633-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt-4633-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750332","alt":"VETTA PT 4633 BASIN white edge repaired product cover v3 20260514"},"vetta-pt2242-wall-mount-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt2242-wall-mount-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750342","alt":"VETTA PT2242 WALL MOUNT BASIN white edge repaired product cover v3 20260514"},"vetta-pt2252-wall-mount-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt2252-wall-mount-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750351","alt":"VETTA PT2252 WALL MOUNT BASIN white edge repaired product cover v3 20260514"},"vetta-pt400gs-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt400gs-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750360","alt":"VETTA PT400GS BASIN white edge repaired product cover v3 20260514"},"vetta-pt4837-semi-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt4837-semi-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750368","alt":"VETTA PT4837 SEMI BASIN white edge repaired product cover v3 20260514"},"vetta-pt6040-countert-top-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-pt6040-countert-top-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750377","alt":"VETTA PT6040 COUNTER TOP BASIN white edge repaired product cover v3 20260514"},"vetta-yb4030-basin":{"url":"https://cdn.shopify.com/s/files/1/0752/0252/7551/files/vetta-yb4030-basin-white-edge-repaired-cover-v3-20260514.png?v=1778750404","alt":"VETTA YB4030 BASIN white edge repaired product cover v3 20260514"}};
  var collectionPaths = new Set(["/collections/wash-basin","/collections/counter-top-basin","/collections/wall-mounted-basin","/collections/under-mount-basin","/collections/standing-basin","/collections/basin-cabinet"]);
  var productPaths = new Set(Object.keys(coverMap).map(function(handle){ return '/products/' + handle; }));
  var basinView = "codex-basin-v7";
  var onBasinCollection = collectionPaths.has(window.location.pathname);
  function imageUrl(url, width) { return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width; }
  function setCoverImage(img, cover) {
    if (!img || !cover || !cover.url) return;
    img.src = imageUrl(cover.url, 900);
    img.srcset = [165, 360, 533, 720, 900, 1200, 1600].map(function(width){ return imageUrl(cover.url, width) + ' ' + width + 'w'; }).join(', ');
    img.sizes = '(max-width: 749px) 92vw, (max-width: 989px) 45vw, 28vw';
    img.alt = cover.alt || img.alt || 'Product cover';
    img.style.objectFit = 'contain';
    img.style.objectPosition = 'center center';
    img.style.backgroundColor = '#fff';
  }
  function parsed(href) { try { return new URL(href, window.location.origin); } catch (error) { return null; } }
  function handleFromPath(pathname) {
    var match = pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }
  function rewriteUrl(url) {
    if (!url || url.origin !== window.location.origin) return null;
    if (!collectionPaths.has(url.pathname) && !productPaths.has(url.pathname) && !(onBasinCollection && url.pathname.indexOf('/products/') === 0)) return null;
    url.searchParams.set('view', basinView);
    return url.pathname + url.search + url.hash;
  }
  function rewriteAnchor(anchor) {
    var url = parsed(anchor.getAttribute('href') || anchor.href || '');
    var next = rewriteUrl(url);
    if (next) anchor.setAttribute('href', next);
    var handle = url ? handleFromPath(url.pathname) : null;
    var cover = handle && coverMap[handle];
    if (!cover) return;
    var card = anchor.closest('.card-wrapper, .product-card-wrapper, .grid__item, li, .card') || anchor.parentElement;
    if (!card) return;
    card.querySelectorAll('img').forEach(function(img){ setCoverImage(img, cover); });
  }
  function rewriteCards(root) {
    (root || document).querySelectorAll('a[href]').forEach(rewriteAnchor);
  }
  function rewriteProductPage() {
    var handle = handleFromPath(window.location.pathname);
    var cover = handle && coverMap[handle];
    if (!cover) return;
    var imgs = Array.prototype.slice.call(document.querySelectorAll('media-gallery img, .product__media-list img, .product__media img, .product-media-modal img, modal-dialog img'));
    imgs.forEach(function(img, index){
      var src = (img.currentSrc || img.src || img.getAttribute('srcset') || '').toLowerCase();
      var alt = (img.alt || '').toLowerCase();
      if (index === 0 || src.indexOf('white-rendered-cover-v2-20260514') !== -1 || alt.indexOf('white rendered product cover v2') !== -1 || src.indexOf('white-background-product-cover-20260514') !== -1 || alt.indexOf('white background product cover') !== -1) {
        setCoverImage(img, cover);
      }
    });
  }
  function run(root) { rewriteCards(root || document); rewriteProductPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }
  new MutationObserver(function(records){
    records.forEach(function(record){
      record.addedNodes.forEach(function(node){
        if (node.nodeType !== 1) return;
        run(node.matches && node.matches('a[href], img') ? node.parentElement || node : node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* codex-basin-global-v2:end */
/* bc-contact-refresh-20260724:start */
(() => {
  const isContactPage = location.pathname.replace(/\/$/, '') === '/pages/contact';
  if (!isContactPage) return;

  const newSectionId = 'template--26654542627135__codex_contact_redesign_v2_20260724';
  const oldSectionId = 'template--26654542627135__484aeb6a-9621-464a-af9f-a346374f8cc1';
  const formSectionId = 'template--26654542627135__form';

  const mountLatestContactBlock = async () => {
    const currentSection = document.getElementById('shopify-section-' + newSectionId);
    const pageText = document.body.innerText || '';
    if (currentSection && pageText.includes('For the fastest assistance')) return;

    const oldSection = document.getElementById('shopify-section-' + oldSectionId);
    const formSection = document.getElementById('shopify-section-' + formSectionId);

    try {
      const response = await fetch(location.pathname + '?section_id=' + encodeURIComponent(newSectionId) + '&_bc_contact_refresh=' + Date.now(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return;

      const html = await response.text();
      if (!html || !html.includes('bc-contact-page') || !html.includes('For the fastest assistance')) return;

      const holder = document.createElement('div');
      holder.innerHTML = html.trim();
      const latestSection = holder.firstElementChild;
      if (!latestSection) return;

      if (currentSection) {
        currentSection.replaceWith(latestSection);
      } else if (oldSection) {
        oldSection.replaceWith(latestSection);
      } else if (formSection) {
        formSection.before(latestSection);
      }
    } catch (error) {
      console.warn('Bath Creature contact refresh skipped', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountLatestContactBlock, { once: true });
  } else {
    mountLatestContactBlock();
  }
})();
/* bc-contact-refresh-20260724:end */


/* codex-lume-nav-global-reveal-20260724-start */
(function(){
  var href = '/pages/bath-creature-signature-lume-v2';
  function hasLumeLink() {
    return !!document.querySelector('header a[href*="/pages/bath-creature-signature-lume"], .menu-drawer a[href*="/pages/bath-creature-signature-lume"], #menu-drawer a[href*="/pages/bath-creature-signature-lume"]');
  }
  function buildLink(text, classes) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    a.className = classes || '';
    a.setAttribute('data-codex-lume-nav', '20260724');
    return a;
  }
  function insertDesktop() {
    var list = document.querySelector('.header__inline-menu ul.list-menu--inline');
    if (!list || list.querySelector('a[data-codex-lume-nav="20260724"], a[href*="/pages/bath-creature-signature-lume"]')) return;
    var li = document.createElement('li');
    li.appendChild(buildLink('LUME', 'header__menu-item list-menu__item link link--text focus-inset'));
    var collectionsItem = Array.from(list.children).find(function(item){ return /collections/i.test(item.textContent || ''); });
    list.insertBefore(li, collectionsItem && collectionsItem.nextSibling ? collectionsItem.nextSibling : list.children[2] || null);
  }
  function insertMobile() {
    var list = document.querySelector('#menu-drawer ul.menu-drawer__menu, .menu-drawer ul.menu-drawer__menu, .menu-drawer__menu');
    if (!list || list.querySelector('a[data-codex-lume-nav="20260724"], a[href*="/pages/bath-creature-signature-lume"]')) return;
    var li = document.createElement('li');
    li.appendChild(buildLink('LUME', 'menu-drawer__menu-item list-menu__item link link--text focus-inset'));
    var collectionsItem = Array.from(list.children).find(function(item){ return /collections/i.test(item.textContent || ''); });
    list.insertBefore(li, collectionsItem && collectionsItem.nextSibling ? collectionsItem.nextSibling : list.children[2] || null);
  }
  function revealLumeNav() {
    insertDesktop();
    insertMobile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealLumeNav);
  else revealLumeNav();
  window.addEventListener('pageshow', revealLumeNav);
  document.addEventListener('shopify:section:load', revealLumeNav);
  setTimeout(revealLumeNav, 300);
  setTimeout(revealLumeNav, 1200);
  setTimeout(revealLumeNav, 3000);
})();
/* codex-lume-nav-global-reveal-20260724-end */

/* codex-lume-stale-route-bridge-20260725 start */
(function () {
  var routes = {
    '/pages/lume-ks01-dimensions': '/pages/lume-ks01-technical-v3',
    '/pages/lume-ks02-dimensions': '/pages/lume-ks02-technical-v3',
    '/pages/lume-ks03-dimensions': '/pages/lume-ks03-technical-v3',
    '/pages/bath-creature-signature-lume': '/pages/bath-creature-signature-lume-v2'
  };
  var path = window.location.pathname.replace(/\/$/, '');
  var target = routes[path];
  if (target) window.location.replace(target + window.location.search + window.location.hash);
})();
/* codex-lume-stale-route-bridge-20260725 end */
